export const slippageInputPattern = '^[0-9]*[.,]?[0-9]{0,2}$'
export const numberInputPattern = '^[0-9]+$'
